import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { environment } from '@environments/environment.base';
import { QueryService } from '@services/query.service';

@Pipe({
    name: 'time'
})
export class TimePipe implements PipeTransform {
    defaultTimeFormat: string = environment.settings.input.timeFormat;
    private datePipe = inject(DatePipe);
    private queryService = inject(QueryService);

    constructor() {
        this.getDefaultTimeFormat();
    }

    transform(value: Date | string): string | null {
        return this.datePipe.transform(value, this.defaultTimeFormat);
    }

    private getDefaultTimeFormat() {
        const settings = this.queryService.queryClient.getQueryData<Setting[]>(['settings']);
        if (!settings) return;
        const defaultTimeFormat = settings.find(
            (setting: Setting) => setting.key === SettingKeyCodes.TimeFormat
        )?.value;
        if (defaultTimeFormat) this.defaultTimeFormat = defaultTimeFormat;
    }
}
